/**
 * An editor placed on the drawing, centred on what it edits, kept inside the
 * drawing: near an edge it would run under the panes beside it. Nudged by a
 * margin, so its own transform (centring it) is left alone, and again as it
 * grows (a new fluid's name field appearing).
 */
import { useLayoutEffect, type RefObject } from "react";

const GAP = 6;

export function useKeepInside(ref: RefObject<HTMLElement | null>): void {
  useLayoutEffect(() => {
    const element = ref.current;
    const parent = element?.offsetParent;
    if (!element || !parent) return;
    const fit = () => {
      element.style.marginLeft = "";
      element.style.marginTop = "";
      const box = element.getBoundingClientRect();
      const bounds = parent.getBoundingClientRect();
      const shift = (start: number, end: number, from: number, to: number) =>
        start < from + GAP ? from + GAP - start : end > to - GAP ? Math.max(to - GAP - end, from + GAP - start) : 0;
      const dx = shift(box.left, box.right, bounds.left, bounds.right);
      const dy = shift(box.top, box.bottom, bounds.top, bounds.bottom);
      if (dx) element.style.marginLeft = `${dx}px`;
      if (dy) element.style.marginTop = `${dy}px`;
    };
    fit();
    if (typeof ResizeObserver === "undefined") return;
    const observer = new ResizeObserver(fit);
    observer.observe(element);
    return () => observer.disconnect();
  }, [ref]);
}
